module.exports = __webpack_public_path__ + "static/bidali-cashback-english-ecec46bdee30379db85b83afd0e575f6.jpg";